import { TableWithPaginationWrapper } from 'components/Table/styles'
import styled, { css } from 'styled-components'
import theme from 'theme_'

export const HomeSystemStatesTableInnerWrapper = styled.div`
  @media ${theme.devices.tablet} {
    min-width: ${theme.breakpoint.tablet};
  }
`

export const HomeSystemStatesTableOuterWrapper = styled(
  TableWithPaginationWrapper
)`
  @media ${theme.devices.tablet} {
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.02);
    border-radius: 8px;
    margin-bottom: 8px;
  }
`

export const HomeSystemStatesCellName = styled.div`
  font-weight: 900;
  width: 100%;
`

export const HomeSystemStatesCellStyles = css`
  line-break: auto;
  word-break: break-all;
  padding: 12px;
`

export const HomeSystemStatesRowStyles = css`
  height: auto;
  min-height: 40px;
  align-items: center;
`
